import { FC, ReactNode } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Flex, Tooltip } from 'antd';
import cn from 'classnames';

import { TranslationNamespace } from '@/i18n';

import styles from './ChoiceWithIcon.module.scss';

type Props = {
	icon: ReactNode;
	name: string;
	descriptionList: string[];
	disabled?: boolean;
	canTransfer?: boolean;
	onClick: () => void;
};

export const ChoiceWithIcon: FC<Props> = ({
	descriptionList,
	icon,
	name,
	disabled,
	canTransfer = true,
	onClick,
}) => {
	const { t } = useTranslation(TranslationNamespace.Shared);

	return (
		<Tooltip title={canTransfer ? null : t('choice-with-icon.home-warehouse-transfer-disabled')}>
			<div
				className={cn(styles.card, { [styles.disabled]: !canTransfer })}
				onClick={() => {
					if (!disabled) onClick();
				}}
			>
				<Flex gap={24} align="center">
					<div className={styles.icon}>{icon}</div>
					<div>
						<div className={styles.title}>{name}</div>
						<div className={styles.description}>
							{descriptionList.map((d) => (
								<div key={d}>{d}</div>
							))}
						</div>
					</div>
				</Flex>
			</div>
		</Tooltip>
	);
};
